module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-20-8e5a23a05024d1d732b6e73794e7b95d.svg";